module.exports = __webpack_public_path__ + "img/view.a61bc115.svg";